/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Biaya_OkInputs */

const en_mk_tut_biaya_ok = /** @type {(inputs: Mk_Tut_Biaya_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can see a rupiah figure per agent, and the spending cap is saved on the agent’s page.`)
};

const id_mk_tut_biaya_ok = /** @type {(inputs: Mk_Tut_Biaya_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terlihat angka rupiah per agen, dan batas belanja tersimpan di halaman agen.`)
};

/**
* | output |
* | --- |
* | "You can see a rupiah figure per agent, and the spending cap is saved on the agent’s page." |
*
* @param {Mk_Tut_Biaya_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_biaya_ok = /** @type {((inputs?: Mk_Tut_Biaya_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Biaya_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_biaya_ok(inputs)
	return en_mk_tut_biaya_ok(inputs)
});